import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { ConditionalSplitPlainObject } from '../plainObjects/conditionalSplit.plainObject';
import { StreamPlainObject } from '../plainObjects/stream.plainObject';
import { PARTITION_FUNCTION_CONSTANT } from '../constants';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class ConditionalSplitVisitor extends BaseTransformationVisitor {
    private get _conditionalSplitTransformation(): ConditionalSplitPlainObject {
        return this.transformation as ConditionalSplitPlainObject;
    }

    public visitTransformation(transformationContext: any): void {
        transformationContext.expression().forEach((expression: any) => {
            if (expression.basicFunction && expression.getText().startsWith(PARTITION_FUNCTION_CONSTANT)) {
                this.visit(expression);
            } else {
                this._addExpression(expression);
            }
        });
        const configurationList = transformationContext.configuration();
        if (configurationList && configurationList.length > 0) {
            (configurationList as any[]).forEach((configuration) => {
                if (this._getText(configuration.configName() as string) === 'disjoint') {
                    this._conditionalSplitTransformation.disjoint = this._getText(configuration.getChild(2)).toLowerCase() === 'true';
                }
            });
        }
    }

    public visitOutputTransformed(outputTransformedContext: any): void {
        this._conditionalSplitTransformation.name = this._getText(outputTransformedContext.children[0]);
        const outputStreams = outputTransformedContext.groupName();
        outputStreams.forEach((child: any, index: number) => {
            const streamName = this.visitTransformed(child);
            this._conditionalSplitTransformation.outputStreams.push(new StreamPlainObject(streamName));
        });
    }

    private _addExpression(context: any): void {
        this._conditionalSplitTransformation.conditionExpressions.push(this._getText(context));
    }
}
